import React from 'react'
import './Footer.css';

function footer() {
  return (
    
    <footer>Made with love by <a href="https://github.com/mona-1414">Mona Gomaa</a>.</footer>
    
  )
}

export default footer
